import React, { useState } from "react";
import Menu from "../../components/Menu";
import { useParams, useNavigate } from "react-router-dom";
import api from '../../api'
import Swal from 'sweetalert2'
import Clear from '../../assets/img/remove.svg'
import InputCPF from "../../components/InputCPF";
import InputPhoneMobile from "../../components/InputPhoneMobile";
import InputDate from "../../components/InputDate";
import Validations from '../../Validations'
import LoadingBlock from "../../components/LoadingBlock";
import ModalYesNo from "../../components/ModalYesNo";
import Avatar from '../../assets/img/clients-im.svg'
import InputImageNoChange from "../../components/InputImageNoChange";
import FooterEdit from "../../components/FooterEdit";

import Accordion from 'react-bootstrap/Accordion';


function CustomersEdit() {
    let { id } = useParams();

    const navigate = useNavigate()
    const [showModal, setShowModal] = useState(false)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState({
        name: false,
        cpf: false,
        email: false,
        phoneMobile: false,
        birth: false,
    })
    const [image, setImage] = useState({
        fileReal: '',
        file: ''
    })
    const [verified, setVerified] = useState(null)

    const [name, setName] = useState("")
    const [cpf, setCpf] = useState("")

    const [birth, setBirth] = useState("")
    const [email, setEmail] = useState("")
    const [phoneMobile, setPhoneMobile] = useState("")

    const [isDependent, setIsDependent] = useState(false)
    const [agreements, setAgreements] = useState([])
    const onSubmit = (ev) => {
        ev.preventDefault()
        var errors = {
            name: name.replaceAll(' ', '') === '' ? true : false,
            cpf: !Validations.CPFValid(cpf),
            email: email.replaceAll(' ', '') === '' ? false : !Validations.emailValid(email),
            phoneMobile: phoneMobile.replaceAll(' ', '') === '' ? false : !Validations.PhoneMobile(phoneMobile),
            birth: Validations.DateDDMMAAAAInvalid(birth),
            tipo: isDependent === null ? true : false
        }
        setError(errors)
        var validations = true

        for (const key in errors) {
            if (errors.hasOwnProperty(key) && errors[key] === true) {
                validations = false;
            }
        }

        if (validations) {

            var data = {
                id: id,
                cpf: cpf.replaceAll(".", "").replaceAll("-", ""),
                name: name,
                birth: birth.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3$2$1'),
                recovery_email: email.replaceAll(" ", ""),
                mobile: phoneMobile.replaceAll(' ', '').replaceAll('(', '').replaceAll(')', '').replaceAll('-', ''),
                dependent: isDependent
            }

            setLoading(true)
            api.put("/api/customers", data).then((response) => {


                Swal.fire({
                    title: "Paciente atualizado com sucesso",
                    icon: 'success',
                    confirmButtonColor: '#3c8dbc',
                })


            }).catch((error) => {
                console.error(error)
                Swal.fire({
                    title: "Paciente não atualizado",
                    text: error.message,
                    icon: 'error',
                    confirmButtonColor: '#3c8dbc',
                })
            }).finally(() => {
                setLoading(false)
            })
        }

    }
    const onDelete = () => {
        setShowModal(false)
        setLoading(true)
        api.delete("/api/customers/" + id).then((response) => {
            Swal.fire({
                title: "Paciente excluído com sucesso",
                icon: 'success',
                confirmButtonColor: '#3c8dbc',
            })
            setTimeout(() => {
                Swal.close()
                setTimeout(() => {
                    navigate('/customers')
                }, 750);
            }, 1500);
        }).catch((error) => {
            console.error(error)
            Swal.fire({
                title: "Paciente não excluído",
                text: error.message,
                icon: 'error',
                confirmButtonColor: '#3c8dbc',

            })
        }).finally(() => {
            setLoading(false)
        })

    }

    const screenTela =
        <>
            {loading && <LoadingBlock />}
            <ModalYesNo show={showModal} setShow={setShowModal} affirnName={"Deletar"} negName={"Voltar"} afirmativeFunc={onDelete} message={"Ao excluir um registro não será possivel recuperar"} title={"Tem certeza?"} imgSVG={Clear} />

            <form onSubmit={onSubmit}>
                <div className='screenContainer edit-mode'>
                    <h1>Paciente</h1>
                    <div className="row">
                        <h4>Dados Básicos</h4>
                        <div style={{position:"relative"}} className="d-flex justify-content-center col-12 col-sm-4 col-lg-4">
              
                            <InputImageNoChange imageAvatar={Avatar} image={image} verification={verified} />
                        </div>
                        <div className="col-12 col-sm-4 col-lg-4 row" style={{ padding: '0px', margin: '-1px' }}>
                            <div className="col-12">
                                <label className="form-label-input">Nome*</label>
                                <input className="form-control" value={name} type="text" name="name" placeholder="Nome" onChange={value => setName(value.target.value.toUpperCase())} />
                                {error.name && <span className="error" >Campo Inválido</span>}
                            </div>
                            <div className="col-12">
                                <label className="form-label-input">Email</label>
                                <input className="form-control" value={email} onChange={value => setEmail(value.target.value)} type="text" name="email" placeholder="Email" />
                                {error.email && <span className="error" >Campo Inválido</span>}

                            </div>
                            <div className="col-12">
                                <label className="form-label-input">CPF*</label>
                                <InputCPF value={cpf} onChange={setCpf} />
                                {error.cpf && <span className="error" >Campo Inválido</span>}
                            </div>
                        </div>
                        <div className="col-12 col-sm-4 col-lg-4 row" style={{ padding: '0px', margin: '-1px' }}>
                            <div className="col-12">
                                <label className="form-label-input">Data de Nascimento</label>
                                <InputDate value={birth} onChange={setBirth} />
                                {error.birth && <span className="error" >Campo Inválido</span>}

                            </div>
                            <div className="col-12">
                                <label className="form-label-input">Celular</label>
                                <InputPhoneMobile value={phoneMobile} onChange={setPhoneMobile} />
                                {error.phoneMobile && <span className="error" >Campo Inválido</span>}
                            </div>
                            <div className="col-12">
                                <label className="form-label-input">Tipo*</label>
                                <div>
                                    <div className="form-check form-check-inline">
                                        <input onChange={() => {
                                            setIsDependent(false)
                                        }} className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" checked={!isDependent} />
                                        <label className="form-check-label" htmlFor="inlineRadio1">Próprio</label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input onChange={() => {
                                            setIsDependent(true)
                                        }} className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" checked={isDependent} />
                                        <label className="form-check-label" htmlFor="inlineRadio2">Dependente</label>
                                    </div>
                                </div>

                                {error.tipo && <span className="error" >Campo Inválido</span>}
                            </div>

                        </div>
                    </div>
                    <div style={{ marginTop: '20px' }} className="row row-mod-hei">
                        <Accordion >
                            <Accordion.Item eventKey="1">
                                <Accordion.Header> <h4>Convênios</h4></Accordion.Header>
                                <Accordion.Body>
                                    {
                                        agreements.length === 0 ? <div><h6 style={{ textAlign: 'center', marginTop: '0px' }}>Sem Convênios</h6></div> :
                                            <div className="row">
                                                {
                                                    agreements.map((elem, index) => {
                                                        return <div key={index} style={{ padding: "0px 10px" }} className="col-12 col-sm-6 col-lg-4">
                                                            <div className="row card-shoppers-place">
                                                                <div className="col-12">
                                                                    {elem}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    })
                                                }
                                            </div>
                                    }
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>
                </div>
                <FooterEdit navigateRoute={"/customers"} onClickDel={() => {
                    setShowModal(true)
                }} />
            </form>
        </>
    React.useEffect(() => {
        api.get('/api/customers/' + id).then((response) => {
            var data = response.data.data

            setImage({
                fileReal: '',
                file: response.data.data.image
            })
            setVerified(data.verified)
            setName(data.name)
            setEmail(data.recovery_email === null ? "" : data.recovery_email)
            setCpf(data.cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4"))

            setBirth(data.birth === null ? "" : data.birth.replaceAll("-", "").replace(/^(\d{4})(\d{2})(\d{2})/, "$3/$2/$1"))

            setPhoneMobile(data.mobile === null ? "" : data.mobile.replaceAll("(", "").replaceAll(")", "").replaceAll("-", "").replace(/^(\d{2})(\d{1})(\d{4})(\d{4})/, "($1) $2 $3 - $4"))

            setAgreements(data.agreements === null ? [] || data.agreements === "" : data.agreements.split(/\s*;\s*/))
            setIsDependent(data.dependent)

        }).catch((error) => {
            console.error('Error fetching customers:', error);
        }).finally(() => {

        })
    }, [id])
    return (
        <Menu screen={screenTela} />
    )
}

export default CustomersEdit;